import { Box, Typography } from '@mui/material'

function PaymentDescription({
  title,
  description,
  marginTop = 0,
  marginBottom = 2
}) {
  return (
    <Box
      sx={{
        backgroundColor: '#F9FAFB',
        padding: '12px 14px',
        borderRadius: '8px',
        marginTop,
        marginBottom
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          marginBottom: 0.5
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          lineHeight: 1.5
        }}
      >
        {description}
      </Typography>
    </Box>
  )
}

export default PaymentDescription